import {
  ORDER_FEATURES,
  OrderFeature,
  OrderFeatureDefinition,
  schFireplaceTypes,
  schGarageTypes,
  schPorchPatioDeckSubtypes,
} from '@aloft/toolkit-shared';
import { toOpts } from '@aloft/toolkit-sui';

import {
  getAloftAreaJSONPropertyGridField,
  getAloftPriceJSONPropertyGridField,
  getCraftsmanQualityPropertyGridField,
  getNumberPropertyGridField,
} from '../../components/PropertyGrid/fields/utils.tsx';
import { PropertyGridField } from '../../components/PropertyGrid/types.ts';

type FeatureGridOrderFeatures = {
  [feature in OrderFeature]: OrderFeatureDefinition & {
    propertyGridFields: PropertyGridField[];
  };
};

export const FEATURE_GRID_ORDER_FEATURES: FeatureGridOrderFeatures = {
  adu: {
    ...ORDER_FEATURES.adu,
    propertyGridFields: [
      getAloftAreaJSONPropertyGridField('editableData.improvements.adu.area'),
      getCraftsmanQualityPropertyGridField('editableData.improvements.adu.quality'),
      getNumberPropertyGridField('editableData.improvements.adu.fullBaths', 'Baths, Full'),
      getNumberPropertyGridField('editableData.improvements.adu.halfBaths', 'Baths, Half'),
    ],
  },
  attic: {
    ...ORDER_FEATURES.attic,
    propertyGridFields: [
      getAloftAreaJSONPropertyGridField('editableData.improvements.attic.area'),
      getCraftsmanQualityPropertyGridField('editableData.improvements.attic.quality'),
    ],
  },
  barn: {
    ...ORDER_FEATURES.barn,
    propertyGridFields: [
      getAloftAreaJSONPropertyGridField('editableData.improvements.barn.area'),
      getCraftsmanQualityPropertyGridField('editableData.improvements.barn.quality'),
    ],
  },
  basement: {
    ...ORDER_FEATURES.basement,
    propertyGridFields: [
      getAloftAreaJSONPropertyGridField(
        'editableData.improvements.basement.totalArea',
        'Total Area',
      ),
      getAloftAreaJSONPropertyGridField(
        'editableData.improvements.basement.finishedArea',
        'Finished Area',
      ),
      getNumberPropertyGridField('editableData.improvements.basement.fullBaths', 'Baths, Full'),
      getNumberPropertyGridField('editableData.improvements.basement.halfBaths', 'Baths, Half'),
    ],
  },
  carport: {
    ...ORDER_FEATURES.carport,
    propertyGridFields: [
      getAloftAreaJSONPropertyGridField('editableData.improvements.carport.area'),
      getNumberPropertyGridField('editableData.improvements.carport.spaces', 'Spaces'),
      getCraftsmanQualityPropertyGridField('editableData.improvements.carport.quality'),
    ],
  },
  deck: {
    ...ORDER_FEATURES.deck,
    propertyGridFields: [
      {
        fieldName: 'editableData.improvements.deck.type',
        label: 'Type',
        options: toOpts(schPorchPatioDeckSubtypes.options),
      },
      getAloftAreaJSONPropertyGridField('editableData.improvements.deck.area'),
      getCraftsmanQualityPropertyGridField('editableData.improvements.deck.quality'),
    ],
  },
  fireplace: {
    ...ORDER_FEATURES.fireplace,
    propertyGridFields: [
      {
        fieldName: 'editableData.improvements.fireplace.type',
        label: 'Type',
        options: toOpts(schFireplaceTypes.options),
      },
      getNumberPropertyGridField('editableData.improvements.fireplace.count', 'Count'),
    ],
  },
  garage: {
    ...ORDER_FEATURES.garage,
    propertyGridFields: [
      {
        fieldName: 'editableData.improvements.garage.type',
        label: 'Type',
        options: toOpts(schGarageTypes.options),
      },
      getAloftAreaJSONPropertyGridField('editableData.improvements.garage.area'),
      getNumberPropertyGridField('editableData.improvements.garage.spaces', 'Spaces'),
      getCraftsmanQualityPropertyGridField('editableData.improvements.garage.quality'),
    ],
  },
  manualCost: {
    ...ORDER_FEATURES.manualCost,
    propertyGridFields: [
      {
        fieldName: 'editableData.improvements.manualCostDisplayName',
        label: 'Display Name',
      },
      getAloftPriceJSONPropertyGridField('editableData.improvements.manualCost'),
    ],
  },
  patio: {
    ...ORDER_FEATURES.patio,
    propertyGridFields: [
      {
        fieldName: 'editableData.improvements.patio.type',
        label: 'Type',
        options: toOpts(schPorchPatioDeckSubtypes.options),
      },
      getAloftAreaJSONPropertyGridField('editableData.improvements.patio.area'),
      getCraftsmanQualityPropertyGridField('editableData.improvements.patio.quality'),
    ],
  },
  pool: {
    ...ORDER_FEATURES.pool,
    propertyGridFields: [
      getAloftAreaJSONPropertyGridField('editableData.improvements.pool.area'),
      getCraftsmanQualityPropertyGridField('editableData.improvements.pool.quality'),
    ],
  },
  porch: {
    ...ORDER_FEATURES.porch,
    propertyGridFields: [
      {
        fieldName: 'editableData.improvements.porch.type',
        label: 'Type',
        options: toOpts(schPorchPatioDeckSubtypes.options),
      },
      getAloftAreaJSONPropertyGridField('editableData.improvements.porch.area'),
      getCraftsmanQualityPropertyGridField('editableData.improvements.porch.quality'),
    ],
  },
  shed: {
    ...ORDER_FEATURES.shed,
    propertyGridFields: [
      getAloftAreaJSONPropertyGridField('editableData.improvements.shed.area'),
      getCraftsmanQualityPropertyGridField('editableData.improvements.shed.quality'),
    ],
  },
  spa: {
    ...ORDER_FEATURES.spa,
    propertyGridFields: [
      getAloftAreaJSONPropertyGridField('editableData.improvements.spa.area'),
      getCraftsmanQualityPropertyGridField('editableData.improvements.spa.quality'),
    ],
  },
  workshop: {
    ...ORDER_FEATURES.workshop,
    propertyGridFields: [
      getAloftAreaJSONPropertyGridField('editableData.improvements.workshop.area'),
      getCraftsmanQualityPropertyGridField('editableData.improvements.workshop.quality'),
    ],
  },
};
